import type SimulationDto from '@/models/dto/credito/SimulationDto';
import type { SimulationAlternativeDto } from '@/models/dto/credito/SimulationDto';

export class SimulationAlternativeResource {
  simulationId: string;
  releasedAmount: number;
  rateMonth: number;
  installment: number;
  totalAmount: number;
  cetYear: number;
  validUntil: string;
  insuranceIncluded: boolean;

  constructor(dto: SimulationAlternativeDto) {
    this.simulationId = dto.simulationId;
    this.releasedAmount = dto.releasedAmount;
    this.rateMonth = dto.rateMonth;
    this.installment = dto.installment;
    this.totalAmount = dto.totalAmount;
    this.cetYear = dto.cetYear;
    this.validUntil = dto.validUntil;
    this.insuranceIncluded = dto.insuranceIncluded;
  }
}

export default class SimulationResource {
  simulationId: string;
  termMonths: number;
  releasedAmount: number;
  marginAvailable: number;
  rateMonth: number;
  installment: number;
  totalAmount: number;
  cetYear: number;
  validUntil: string;
  insuranceIncluded: boolean;
  insuranceAlternativeAvailable: boolean;
  insuranceAlternative: SimulationAlternativeResource | null;
  /**
   * Teto por prazo (chave = prazo em meses). É o que permite saber, antes de trocar de prazo, se o
   * valor escolhido cabe no prazo de destino: o teto cai junto com o prazo, e o `maximumAmount` das
   * opções é limite de produto no catálogo da UY3, sem relação com a margem da pessoa.
   *
   * Opcional porque o snapshot da aba (sessionStorage) pode ter sido gravado antes deste campo existir.
   */
  maximumByTerm?: Record<string, number>;

  constructor(dto: SimulationDto) {
    this.simulationId = dto.simulationId;
    this.termMonths = dto.termMonths;
    this.releasedAmount = dto.releasedAmount;
    this.marginAvailable = dto.marginAvailable;
    this.rateMonth = dto.rateMonth;
    this.installment = dto.installment;
    this.totalAmount = dto.totalAmount;
    this.cetYear = dto.cetYear;
    this.validUntil = dto.validUntil;
    this.insuranceIncluded = dto.insuranceIncluded;
    this.insuranceAlternativeAvailable = dto.insuranceAlternativeAvailable;
    this.insuranceAlternative = dto.insuranceAlternative
      ? new SimulationAlternativeResource(dto.insuranceAlternative)
      : null;
    this.maximumByTerm = { ...dto.maximumByTerm };
  }
}
